import { render, staticRenderFns } from "./bottom-banner.vue?vue&type=template&id=14a7195c&"
import script from "./bottom-banner.vue?vue&type=script&lang=js&"
export * from "./bottom-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a7195c')) {
      api.createRecord('14a7195c', component.options)
    } else {
      api.reload('14a7195c', component.options)
    }
    module.hot.accept("./bottom-banner.vue?vue&type=template&id=14a7195c&", function () {
      api.rerender('14a7195c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/BottomBannerComponent/bottom-banner.vue"
export default component.exports